import { tns } from 'tiny-slider/src/tiny-slider';

(function () {

  if (!document.querySelector('.item-photo')) return this;

  const slider = tns({
    autoplay: false,
    autoplayButtonOutput: false,
    container: '.item-photo__main',
    // nav: false,
    navContainer: ".item-photo__thumbs",
    navAsThumbnails: true,
    controls: false,
    items: 1,
    mouseDrag: true,
    mode: 'carousel',
    slideBy: 'page',
    speed: 500,
  });

})();
